import React, {Component} from 'react';
import PropTypes from 'prop-types';
import EmployeeResult from './EmployeeResult';
import {connectToStores} from 'fluxible-addons-react';
import { selectEmployee } from '../actions/SearchActionCreators';
import MessageDefinitions from '../i18n/MessageDefinitions';
import { FormattedMessage } from 'react-intl';
import FontAwesome from 'react-fontawesome';

@connectToStores(['LoginStore'], (context, props) => {
  const LoginStore = context.getStore('LoginStore');

  return {
    employees: LoginStore.getEmployees()
  };
})
class Results extends Component {
  static propTypes = {
    employees: PropTypes.array,
    completedSearch: PropTypes.bool
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {employees, completedSearch} = this.props;

    const searchResults = employees.map(item => {
      const employeeClicked = () => {
        this.context.executeAction(selectEmployee, item);
      };

      return <EmployeeResult key={item.id} employee={item} onClick={employeeClicked} />;
    });

    let component = null;

    if (completedSearch && !searchResults.length) {
      component = <div className="employee-login-result empty">
        <FormattedMessage {...MessageDefinitions.noProfiles}/>
      </div>
    }else if (searchResults.length > 0) {
      component = <div>
        <div className="text-center">Click on a profile to login.</div>
        {searchResults}
      </div>
    }

    return <div className="employee-login-results">
      {component}
    </div>;
  }
}

export default Results;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/components/EmployeeResults.js
 **/